import UiConstants from '../lib/UIconstants.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import { formatCurrencyValue, getCurrencySymbol } from './helper/currencies';
import { EVENTS } from '../lib/constants.js';
import { GameConfigs } from '../lib/globals/GameConfigs.js';
import HELPERS from '../lib/globals/helpers/Helpers.js';
import { isMobile, isTablet } from 'react-device-detect';
const intervalDuration = 175;
const events = [
	EVENTS.AUTO_STARTED,
	EVENTS.ERROR_PAGE,
	EVENTS.SETTINGS_UPDATE,
	EVENTS.MODAL,
	EVENTS.DOUBLE_CHANCE
];
class BetAmountController {
	constructor(vc, config) {
		this.vc = vc.holder;
		this.configs = config;
		this.interactive = true;
		this.enabled = false;
		this.isHeldDown = false;
		this.intervalId = null;

		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency, true);
		this.bets = GameConfigs.config.bet_steps;
		this.vc.BET_AMOUNT.BET_AMOUNT_TEXT.text =
			this.vc.BET_AMOUNT.BET_AMOUNT_TEXT.text +
			' (' +
			GameConfigs.auth.balance.currency +
			')';

		this.vc.ui_btn_minus.handler = this.process.bind(this);
		this.vc.ui_btn_plus.handler = this.process.bind(this);
		window.addEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
		window.addEventListener(EVENTS.BET_UPDATE, this, false);
		this.currentIndex = GameConfigs.currentBet
			? this.bets.indexOf(GameConfigs.currentBet)
			: 0;
		this.checkBonus();

		this.vc.BET_AMOUNT.BET_AMOUNT_VALUE.text = this.getBetAmount(
			GameConfigs.currentBet,
			GameConfigs.doubleChance
		);
		this.checkLength(this.vc.BET_AMOUNT.BET_AMOUNT_VALUE);
		this.handleDisable();
		if (isMobile || isTablet) {
			this.addTapEvents();
		} else {
			this.addMouseEvents();
		}
	}
	addMouseEvents() {
		this.vc.ui_btn_minus.on('mousedown', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.startIncrementing(UiConstants.BTN_MINUS);
				this.vc.ui_btn_minus.mouseDownHandler();
			}
		});
		this.vc.ui_btn_plus.on('mousedown', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.startIncrementing(UiConstants.BTN_PLUS);
				this.vc.ui_btn_plus.mouseDownHandler();
			}
		});
		this.vc.ui_btn_minus.on('mouseup', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.stopIncrementing(e);
				this.vc.ui_btn_minus.mouseUpHandler();
			}
		});
		this.vc.ui_btn_plus.on('mouseup', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.stopIncrementing();
				this.vc.ui_btn_plus.mouseUpHandler();
			}
		});
		this.vc.ui_btn_plus.on('mouseupoutside', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.stopIncrementing();
				this.vc.ui_btn_plus.mouseUpHandler();
			}
		});
		this.vc.ui_btn_minus.on('mouseupoutside', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.stopIncrementing();
				this.vc.ui_btn_minus.mouseUpHandler();
			}
		});
	}

	addTapEvents() {
		this.vc.ui_btn_minus.on('touchstart', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.startIncrementing(UiConstants.BTN_MINUS);
				this.vc.ui_btn_minus.mouseDownHandler();
			}
		});
		this.vc.ui_btn_plus.on('touchstart', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.startIncrementing(UiConstants.BTN_PLUS);
				this.vc.ui_btn_plus.mouseDownHandler();
			}
		});
		this.vc.ui_btn_minus.on('touchend', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.stopIncrementing(e);
				this.vc.ui_btn_minus.mouseUpHandler();
			}
		});
		this.vc.ui_btn_plus.on('touchend', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.stopIncrementing();
				this.vc.ui_btn_plus.mouseUpHandler();
			}
		});
		this.vc.ui_btn_plus.on('touchendoutside', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.stopIncrementing();
				this.vc.ui_btn_plus.mouseUpHandler();
			}
		});
		this.vc.ui_btn_minus.on('touchendoutside', (e) => {
			if (!GameConfigs.isFreeSpin) {
				this.stopIncrementing();
				this.vc.ui_btn_minus.mouseUpHandler();
			}
		});
	}

	startIncrementing(e) {
		if (this.intervalId === null) {
			this.intervalId = setInterval(() => {
				this.process(e);
			}, intervalDuration);
		}
	}

	stopIncrementing() {
		if (this.intervalId !== null) {
			clearInterval(this.intervalId);
			this.intervalId = null;
		}
	}

	checkBonus() {
		if (GameConfigs.config.hasbonus) {
			this.handleInteractive(false);
		} else {
			this.handleInteractive(true);
			this.addEventListeners();
			window.addEventListener(EVENTS.BONUS_BUY, this, false);
			window.addEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
			if (
				GameConfigs.settings.keyboard_shortcuts &&
				!window.isMobile &&
				!window.isTablet
			) {
				window.addEventListener('keydown', this, false);
				window.addEventListener('keyup', this, false);
				this.enabled = false;
			}
		}
	}

	addEventListeners() {
		this.handleInteractive(true);
		for (let i = 0; i < events.length; i++) {
			window.addEventListener(events[i], this, false);
		}
	}

	removeEventListener() {
		for (let i = 0; i < events.length; i++) {
			window.removeEventListener(events[i], this, false);
		}
	}
	getBetAmount(bet, double) {
		let amount = double
			? GameConfigs.config.double_steps[
					GameConfigs.config.bet_steps.indexOf(bet)
				]
			: bet;
		return formatCurrencyValue(
			amount,
			this.currency,
			GameConfigs.config.currency_prec,
			false,
			true
		);
	}

	disableButton(b) {
		this.vc.ui_btn_minus.toggleEnabled(b);
		this.vc.ui_btn_plus.toggleEnabled(b);
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.AUTO_STARTED:
				if (evt.detail.isAutoOn) {
					this.interactive = false;
					this.disableButton(false);
				} else {
					this.interactive = true;
					this.disableButton(true);
				}
				break;
			case EVENTS.BONUS_ROUND_STATE:
				if (evt.detail.state === 'started') {
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
					window.removeEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
				}
				break;
			case EVENTS.BONUS_BUY:
				if (evt.detail.bonus) {
					this.removeEvents();
				} else {
					this.addEventListeners();
					window.addEventListener(EVENTS.BET_UPDATE, this, false);
				}
				break;
			case EVENTS.DOUBLE_CHANCE:
				this.vc.BET_AMOUNT.BET_AMOUNT_VALUE.text = this.getBetAmount(
					GameConfigs.currentBet,
					evt.detail.doubleChance
				);
				this.checkLength(this.vc.BET_AMOUNT.BET_AMOUNT_VALUE);
				break;
			case EVENTS.BET_UPDATE:
				this.vc.BET_AMOUNT.BET_AMOUNT_VALUE.text = this.getBetAmount(
					evt.detail.betAmount,
					GameConfigs.doubleChance
				);
				GameConfigs.currentBet = evt.detail.betAmount;
				this.currentIndex = this.bets.indexOf(evt.detail.betAmount);
				this.checkLength(this.vc.BET_AMOUNT.BET_AMOUNT_VALUE);
				this.handleDisable();
				break;
			case EVENTS.ERROR_PAGE:
				if (evt.detail.error) {
					this.removeEvents();
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
				}
				break;
			case 'keydown':
				if (evt.keyCode === 38) {
					this.process(UiConstants.BTN_PLUS);
					this.vc.ui_btn_plus.mouseDownHandler();
				}
				if (evt.keyCode === 40) {
					this.process(UiConstants.BTN_MINUS);
					this.vc.ui_btn_minus.mouseDownHandler();
				}
				break;
			case 'keyup':
				if (evt.keyCode === 38) {
					this.vc.ui_btn_plus.mouseUpHandler();
				}
				if (evt.keyCode === 40) {
					this.vc.ui_btn_minus.mouseUpHandler();
				}
				break;
			case EVENTS.SETTINGS_UPDATE:
				if (window.isMobile || window.isTablet) return;
				if (evt.detail.data.keyboard_shortcuts === undefined) return;
				if (evt.detail.data.keyboard_shortcuts) {
					if (this.enabled) return;
					this.enabled = true;
					window.addEventListener('keydown', this, false);
					window.addEventListener('keyup', this, false);
				} else {
					this.enabled = false;
					window.removeEventListener('keydown', this, false);
					window.removeEventListener('keyup', this, false);
				}
				break;
			case EVENTS.MODAL:
				if (!window.isMobile && !window.isTablet) return;
				if (
					evt.detail.modal === 'settings' ||
					evt.detail.modal === 'quest' ||
					evt.detail.modal === 'quest_claim' ||
					GameConfigs.bonusBuy
				) {
					this.interactive = false;
					this.disableButton(false);
				} else {
					this.interactive = true;
					this.disableButton(true);
				}
				break;
			default:
				break;
		}
	}

	process(str) {
		if (
			GameConfigs.isFreeSpin ||
			GameConfigs.disabled.bet_amount ||
			GameConfigs.quest_is_active ||
			GameConfigs.reelComponent.rotating
		) {
			this.animateDisable();
			return;
		}
		if (this.interactive && !GameConfigs.isFreeSpin) {
			window.restrictModalClose = true;

			switch (str) {
				case UiConstants.BTN_PLUS:
					this.currentIndex++;
					if (this.currentIndex >= this.bets.length) {
						this.currentIndex = this.bets.length - 1;
						this.stopIncrementing();
					}
					window.sm.play({ name: 'bet_amount_increase_sfx' });
					break;
				case UiConstants.BTN_MINUS:
					this.currentIndex--;
					if (this.currentIndex < 0) {
						this.currentIndex = 0;
						this.stopIncrementing();
					}
					window.sm.play({ name: 'bet_amount_decrease_sfx' });
					break;
				default:
					break;
			}
			HELPERS.dispatchCustomEvent(EVENTS.BET_UPDATE, {
				betAmount: this.bets[this.currentIndex]
			});
		} else {
			this.animateDisable();
		}
	}

	handleInteractive(b) {
		this.interactive = b;
		this.vc.ui_btn_minus.interactive = b;
		this.vc.ui_btn_plus.interactive = b;
	}

	handleDisable() {
		this.setButtonState(true, this.vc.ui_btn_minus);
		this.setButtonState(true, this.vc.ui_btn_plus);
		if (this.currentIndex === 0) {
			this.setButtonState(false, this.vc.ui_btn_minus);
			this.vc.ui_btn_minus.mouseUpHandler();
		}
		if (this.currentIndex === this.bets.length - 1) {
			this.setButtonState(false, this.vc.ui_btn_plus);
			this.vc.ui_btn_plus.mouseUpHandler();
		}
	}

	setButtonState(b, btn) {
		btn.alpha = b ? 1 : 0.5;
		btn.interactive = b;
		btn.cursor = b ? 'pointer' : 'none';
	}

	animateDisable() {
		if (this.tween) {
			this.tween = null;
		} else {
			window.sm.play({ name: 'error_sfx' });
			this.tween = new Tween(this.vc)
				.to({ x: 5 }, 10)
				.yoyo(true)
				.repeat(5)
				.easing(Easing.Linear.None)
				.start();
		}
	}
	checkLength(value) {
		//maybe textmetric
		if (value.text.length <= 6) {
			value.style.fontSize = 40;
		}
		if (value.text.length > 7 && value.text.length <= 12) {
			value.style.fontSize = 36;
		}
		if (value.text.length > 12) {
			value.style.fontSize = 22;
		}
	}

	removeEvents() {
		this.handleInteractive(false);
		window.removeEventListener(EVENTS.BET_UPDATE, this, false);
		this.removeEventListener();
	}
}

export default BetAmountController;
